import axios, { AxiosError, AxiosResponse } from "axios";
import { get } from "lodash";
import { BASE_URL, TOKEN_REFRESH } from "./URLs";
import {
  AUTH_LOCAL_STORAGE_KEY,
  getAuth,
  removeAuth,
} from "../components/layout/auth";

const baseURL = BASE_URL;

export const api = axios.create({
  baseURL,
  // headers: {
  //   "Access-Control-Allow-Origin": "*",
  //   Accept: "application/json",
  //   "Cache-Control": "no-cache",
  //   "Content-Type": "application/json",
  // },
});

class APIError {
  status: number;
  data: {
    message: string;
    status: string;
  };

  constructor(data: any, status: number) {
    this.status = status;
    this.data = data;
  }
}

const refresh = async () => {
  try {
    const response = await api.post(TOKEN_REFRESH, {
      refresh: getAuth()?.refresh,
    });
    const newAccessToken = response.data.access;
    setHeaderToken(newAccessToken);
    const lsValue = JSON.stringify({
      access: newAccessToken,
      refresh: getAuth()?.refresh
    })
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
    return newAccessToken;
  } catch (error) {
    console.error("Error refreshing token", error);
    throw error;
  }
};

api.interceptors.response.use(
  (response: AxiosResponse) => {
    console.log(
      "api success",
      response.config.url,
      JSON.stringify(response.data, null, 2)
    );
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  async (err: AxiosError) => {
    console.log(
      "api error",
      err.config?.url,
      JSON.stringify(err.response, null, 2)
    );
    const data = get(err, "response");
    const status = err.response?.status || 500;
    // const response_status = get(err, 'response.data.status', status);

    // we can handle global errors here
    switch (status) {
      // authentication (token related issues)
      case 401: {
        try {
          const newToken = await refresh();
          if (newToken && err.config) {
            err.config.headers['Authorization'] = `Bearer ${newToken}`;
            return api.request(err.config);
          }
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
        // userStore.getState().handleLogOut()
        removeAuth();
        return Promise.reject(new APIError(data || err, 401));
      }

      // forbidden (permission related issues)
      case 403: {
        return Promise.reject(new APIError(data || err, 403));
      }

      // bad request
      case 400: {
        return Promise.reject(new APIError(data || err, status));
      }

      // not found
      case 404: {
        return Promise.reject(new APIError(data || err, 404));
      }

      // conflict
      case 409: {
        return Promise.reject(new APIError(data || err, 409));
      }

      // unprocessable
      case 422: {
        return Promise.reject(new APIError(data || err, 422));
      }

      // generic api error (server related) unexpected
      default: {
        return Promise.reject(new APIError(data || err, 500));
      }
    }
  }
);

export const setHeaderToken = (token: string) => {
  api.defaults.headers.Authorization = `Bearer ${token}`;
};

export const removeHeaderToken = () => {
  delete api.defaults.headers.Authorization;
};
